export const RECALL_DIRECTIONS = ['RECEIVED', 'ISSUED'] as const;
export type RecallDirection = (typeof RECALL_DIRECTIONS)[number];

export const RECALL_KINDS = ['WITHDRAWAL', 'RECALL'] as const;
export type RecallKind = (typeof RECALL_KINDS)[number];

export const RECALL_CASE_STATUSES = ['DRAFT', 'OPEN', 'CLOSED'] as const;
export type RecallCaseStatus = (typeof RECALL_CASE_STATUSES)[number];

export const RECALL_SOURCES = [
  'SUPPLIER_NOTICE',
  'AUTHORITY_NOTICE',
  'INTERNAL_FINDING',
  'CUSTOMER_COMPLAINT',
] as const;
export type RecallSource = (typeof RECALL_SOURCES)[number];

export const RECALL_LOT_MATCH_REASONS = [
  'ORIGIN',
  'SUPPLIER_LOT_MATCH',
  'DERIVED_CHAIN',
  'MANUAL',
] as const;
export type RecallLotMatchReason = (typeof RECALL_LOT_MATCH_REASONS)[number];

export const RECALL_LOT_OUTCOMES = [
  'RETURNED_TO_SUPPLIER',
  'DISPOSED',
  'RELEASED',
  'ALREADY_CONSUMED',
] as const;
export type RecallLotOutcome = (typeof RECALL_LOT_OUTCOMES)[number];

export const RECALL_PARTY_ROLES = ['SUPPLIER', 'CUSTOMER'] as const;
export type RecallPartyRole = (typeof RECALL_PARTY_ROLES)[number];

export const RECALL_NOTICE_STATUSES = ['TO_NOTIFY', 'NOTIFIED', 'ACKNOWLEDGED'] as const;
export type RecallNoticeStatus = (typeof RECALL_NOTICE_STATUSES)[number];

export const RECALL_NOTICE_CHANNELS = ['EMAIL', 'PHONE', 'IN_PERSON', 'OTHER'] as const;
export type RecallNoticeChannel = (typeof RECALL_NOTICE_CHANNELS)[number];

export const LOT_STATUSES_WITH_BLOCKED = ['ACTIVE', 'EXHAUSTED', 'EXPIRED', 'BLOCKED'] as const;
export type LotStatusWithBlocked = (typeof LOT_STATUSES_WITH_BLOCKED)[number];
